import React, { useState } from "react";
import { Button } from "../../ui/button";
import { ButtonGroup } from "../../ui/button-group";
import { HorizontalBarChart } from "./HorizontalBarChart";
import { IncidentCountByIncidentType } from "../../../types/insightDashboard";

interface Measure {
  label: string;
  focusData: IncidentCountByIncidentType[];
  comparisonData: IncidentCountByIncidentType[];
}

interface MeasureToggleBarChartProps {
  title: string;
  description?: string;
  notes?: string[];
  measures: Measure[];
  focusYear: number | string;
  comparisonYear: number | string;
  focusLabel?: string;
  comparisonLabel?: string;
}

// Measures with very different sizes (e.g. impressions vs attendees) would squash each other on
// one scale, so the chart shows one measure at a time with its own scale
export function MeasureToggleBarChart({
  title,
  description,
  notes,
  measures,
  focusYear,
  comparisonYear,
  focusLabel,
  comparisonLabel,
}: MeasureToggleBarChartProps) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectedMeasure = measures[selectedIndex];

  const measureSwitch = (
    <ButtonGroup aria-label={`${title} measure`}>
      {measures.map((measure, index) => (
        <Button
          key={measure.label}
          type="button"
          size="sm"
          variant={index === selectedIndex ? "default" : "outline"}
          aria-pressed={index === selectedIndex}
          onClick={() => setSelectedIndex(index)}
        >
          {measure.label}
        </Button>
      ))}
    </ButtonGroup>
  );

  return (
    <HorizontalBarChart
      title={title}
      description={description}
      notes={notes}
      focusData={selectedMeasure.focusData}
      comparisonData={selectedMeasure.comparisonData}
      focusYear={focusYear}
      comparisonYear={comparisonYear}
      focusLabel={focusLabel}
      comparisonLabel={comparisonLabel}
      headerAction={measureSwitch}
    />
  );
}
